import React from 'react';
import { LockIcon, ShieldCheckIcon, CheckCircleIcon, CreditCardIcon } from 'lucide-react';
interface TrustBadgesProps {
  className?: string;
  theme?: 'light' | 'dark';
}
export function TrustBadges({
  className = '',
  theme = 'dark'
}: TrustBadgesProps) {
  const textColor = theme === 'dark' ? 'text-white/50' : 'text-gris';
  const mpColor = theme === 'dark' ? 'text-[#00b1ea]' : 'text-[#009ee3]';
  return <div className={`flex justify-center gap-5 mt-4 flex-wrap ${className}`} data-id="element-300">
      <span className="flex items-center gap-2" data-id="element-301">
        <img src="https://i.postimg.cc/fTq3bkzL/mercado-pago-750x375.webp" alt="Mercado Pago" className="h-6 w-auto object-contain" data-id="element-302" />
      </span>
      <span className={`flex items-center gap-1.5 text-[14px] md:text-[13px] font-medium ${textColor}`} data-id="element-303">
        <LockIcon className="w-4 h-4 opacity-70" data-id="element-304" />
        Compra 100% Segura
      </span>
      <span className={`flex items-center gap-1.5 text-[14px] md:text-[13px] font-medium ${textColor}`} data-id="element-305">
        <ShieldCheckIcon className="w-4 h-4 opacity-70" data-id="element-306" />
        Garantía 7 días
      </span>
      <span className={`flex items-center gap-1.5 text-[14px] md:text-[13px] font-medium ${textColor}`} data-id="element-307">
        <CheckCircleIcon className="w-4 h-4 opacity-70" data-id="element-308" />
        Acceso inmediato
      </span>
    </div>;
}